module.exports = __webpack_public_path__ + "static/media/Quicksand-Regular.c52f5f21.woff";